import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getBusinesses(params = {}) {
  return axios.get('/ajax/businesses', { params })
}
export function getBusiness(id) {
  return axios.get(`/ajax/businesses/${id}`)
}
export function createBusiness(data) {
  const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}
  return axios.post('/ajax/businesses', data, config)
}
export function updateBusiness(id, data) {
  const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}
  return axios.patch(`/ajax/businesses/${id}`, data, config)
}
export function destroyBusiness(id) {
  return axios.delete(`/ajax/businesses/${id}`)
}
export function archiveBusiness(id) {
  return axios.patch(`/ajax/businesses/${id}/archive`)
}
export function unarchiveBusiness(id) {
  return axios.patch(`/ajax/businesses/${id}/unarchive`)
}
export function getGbpCategories() {
  return axios.get('/ajax/businesses/categories')
}
